module.exports = __webpack_public_path__ + "img/restauration.2afe24c9.webp";